// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const SupportIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="SupportIcon" ref={forwardedRef} {...props}>
      <path d="M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0m-3.965 5.096-1.787-1.787A4 4 0 0 1 10 14a4 4 0 0 1-2.284-.716L5.93 15.07A6.47 6.47 0 0 0 10 16.5a6.47 6.47 0 0 0 4.035-1.404m-7.368-2.884A4 4 0 0 1 6 10a4 4 0 0 1 .667-2.212l-1.79-1.79A6.47 6.47 0 0 0 3.5 10a6.47 6.47 0 0 0 1.377 4.001zm8.429 1.823A6.47 6.47 0 0 0 16.5 10a6.47 6.47 0 0 0-1.43-4.07l-1.786 1.786A4 4 0 0 1 14 10a4 4 0 0 1-.691 2.248zM10 3.5a6.47 6.47 0 0 0-4.07 1.43l1.786 1.786A4 4 0 0 1 10 6a4 4 0 0 1 2.212.667l1.79-1.79A6.47 6.47 0 0 0 10 3.5m2.5 6.5a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const SupportIcon = /* @__PURE__ */ Object.assign(SupportIconComponent, {
  displayName: 'SupportIcon',
});
